var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$props.url != null)?_c('div',[_c('embed',{attrs:{"src":_vm.$props.url,"width":"100%","height":"1200"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }